(ns frontend.ux-overhaul.listing.zap-vault.event
  (:require [frontend.view.entity :as entity]
            [re-frame.core :as rf]))

(rf/reg-event-fx
 ::create-zap-vault
 (fn [_ _]
   (entity/open-creator! :entity.type/zap-vault {})
   {}))
